import React, { Fragment } from "react";
import { Card, CardImg, CardBody } from "reactstrap";
import styled from "styled-components";
import { data } from "./data/WorksData";
import StrapModal from "./StrapModal";
import { Fade } from "react-reveal";

export default class Work extends React.Component {
  constructor() {
    super();
    this.state = {
      activeCategory: "all",
      showModal: false,
      workTimes: [1]
    };
  }
  handleCategory = category => {
    this.setState({
      activeCategory: category
    });
  };
  handleCard = element => {
    this.setState({
      element: element,
      showModal: !this.state.showModal
    });
  };
  loadMore = () => {
    this.setState({
      workTimes: [...this.state.workTimes, 1]
    })
  };
  render() {
    return (
      <Fade right duration={1000} distance="20px">

      <div className="container work remove-padding">
        {this.state.showModal ? (
          <StrapModal
            handleCard={this.handleCard}
            modal={this.state.showModal}
            element={this.state.element}
          />
        ) : null}

       <span className="projects"> Certificates </span>
        <div className="work-filter ">  

          <span onClick={() => this.handleCategory("all")}>All - </span>
          <span onClick={() => this.handleCategory("certification")}>Certifications -</span>
          <span onClick={() => this.handleCategory("web")}>Website -</span>
          <span onClick={() => this.handleCategory("SAP")}>SAP -</span>
          <span onClick={() => this.handleCategory("design")}>Design </span>
          <span onClick={() => this.handleCategory("Artificial Intelligence")}>
            Artificial intelligence</span>
            
        </div>
 
        <div className="cards-container">
          {this.state.workTimes.map((ele, key) => {
            return (
              <Cards

                key={key}
                handleCard={this.handleCard}
                activeCategory={this.state.activeCategory}
              />
            );
          })}
        </div>
      </div>
 
     </Fade> 
    );
  }
}


const Cards = props => {
  return (
    <Fragment>
      {data.map((ele, key) => {
        return (
          <CardSC key={key}
          category={ele.category}
          activecategory={props.activeCategory}>
            <CardImg
              src={require(`../static/img/work/${ele.image}`)}
              alt="Card image cap"
              className="img-card"
            />
            <CardBody className="body-card">
              <span className="card-category">  {ele.date} - {ele.category} </span>
              <span className="card-title"> {ele.title} </span>
              <span className="card-authority"> {ele.authority}  </span>
              <span className="card-tools"> {ele.tools}  </span>


            </CardBody>
          </CardSC>
        );
      })}
      
    </Fragment>
    
  );
};

const CardSC = styled(Card)`
  ${props =>
    props.activecategory === props.category || props.activecategory === "all"
      ? "opacity:1;visibility:visible"
      : "opacity:0;visibility:hidden;position:absolute"};
  transition: opacity 600ms, visibility 600ms;
`;



// WEBPACK FOOTER //
// ./src/components/Work.js